import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import styled, { CSSObject } from 'styled-components';
import { theme } from '../../styles/theme';

type IBadgeRoundSize = 'default' | 'regular' | 'small';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size: IBadgeRoundSize;
  bgColor?: string;
}

const roundBadgeSizeStyles: Record<IBadgeRoundSize, CSSObject> = {
  default: {
    width: 24,
    height: 24,
    fontSize: 12,
  },
  regular: {
    width: 18,
    height: 18,
    fontSize: 14,
  },
  small: {
    width: 16,
    height: 16,
    fontSize: 12,
  },
};

const StyledBadge = styled.div<{ $size: IBadgeRoundSize; $bgColor?: string }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1px;
  border-radius: 50%;
  font-weight: 600;
  user-select: none;
  background-color: ${({ $bgColor }) => $bgColor || theme.colors.secondary800};
  color: ${theme.colors.inverse};
  ${({ $size }) => roundBadgeSizeStyles[$size]};
`;

const BadgeRound = forwardRef<HTMLDivElement, IProps>(
  ({ children, size, bgColor, ...props }, ref) => (
    <StyledBadge ref={ref} {...props} $size={size} $bgColor={bgColor}>
      {children}
    </StyledBadge>
  ),
);

export default BadgeRound;
